module.exports = __webpack_public_path__ + "static/media/how_we_work3.86d8bb96.svg";